// Angular
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
// RxJS
import { map } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState } from '../state/root';
import { selectLoggedInUser } from '../state/user/user.selectors';
export function createRoleGaurd(...requiredPermissions: string[]): CanActivateFn {
    return (route, state) => {
        const store: Store<AppState> = inject(Store<AppState>);
        return store.pipe(
            select(selectLoggedInUser),
            map(e => {
                return e.hasPermissions(...requiredPermissions)
            })
        )
    }
}

